import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/client/lib/utils';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className, ...props }, ref) {
    return (
      <input
        ref={ref}
        className={cn(
          'block w-full h-11 rounded-md px-4',
          'bg-white/70 backdrop-blur-md',
          'border border-glass-border-strong',
          'font-sans text-body text-text-primary',
          'placeholder:text-text-muted',
          'transition-[border-color,box-shadow,background] duration-200',
          'hover:border-primary/30',
          'focus-visible:outline-none focus-visible:border-primary',
          'focus-visible:bg-white focus-visible:shadow-glow',
          'disabled:opacity-55 disabled:cursor-not-allowed',
          className,
        )}
        {...props}
      />
    );
  },
);
